import { css } from 'styled-components';

export default css`
  :root {
    --Number-6: 1.5rem;
    --Number-9: 2.25rem;
    --swiper-pagination-bottom: -24px;
  }
`;
